import React from 'react'

import { DESCRIPTION_CUTOFFS } from './Constants'
import { ListingDescriptionP, ListingSpan } from './Styled'

const ListingDescription = ({ description }) => (
  <>
    <ListingDescriptionP>
      <ListingSpan display={{ _: 'none', desktop: 'inline' }}>
        {description.substring(0, DESCRIPTION_CUTOFFS.LARGE).trim()}
        {description.length > DESCRIPTION_CUTOFFS.LARGE && '…'}
      </ListingSpan>
      <ListingSpan display={{ _: 'inline', desktop: 'none' }} />
    </ListingDescriptionP>
  </>
)

export default ListingDescription
